var React = require('react');

function AudioPlay (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16.5","cy":"16.5","r":"16.5","fill":"#9646C3","key":0}),React.createElement("g",{"clipPath":"url(#clip0_53_4671)","key":1},React.createElement("path",{"d":"M23.9432 16.3896L12.7432 10.0896C12.5262 9.96783 12.2616 9.97063 12.0474 10.0952C11.8318 10.2212 11.7002 10.4508 11.7002 10.7V23.3C11.7002 23.5492 11.8318 23.7788 12.0474 23.9048C12.1566 23.9678 12.2784 24 12.4002 24C12.5178 24 12.6368 23.9706 12.7432 23.9104L23.9432 17.6104C24.163 17.4858 24.3002 17.2534 24.3002 17C24.3002 16.7466 24.163 16.5142 23.9432 16.3896Z","fill":"white"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_53_4671"},React.createElement("rect",{"width":"14","height":"14","fill":"white","transform":"translate(11 10)"})))]);
}

AudioPlay.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = AudioPlay;

AudioPlay.default = AudioPlay;
